import { applyWhenValue, schema, validateStandardSchema, type SchemaPath } from '@angular/forms/signals';
import { z } from 'zod';

const emailSchema = schema<string>(email => {
  validateStandardSchema(email, z.email());
});

export function applyEmailSchema(field: SchemaPath<string>) {
  applyWhenValue(field, v => v.length > 0, emailSchema);
}
